import setSiteMeta from '../base-saving-actions/set-site-meta';

const updatePages = (pages) =>
  pages.reduce(
    (saveActions, { html, htmlCheckpoint, ...page }) => [
      ...saveActions,
      setSiteMeta(['pages', page.id], page),
    ],
    []
  );

export default updatePages;
